import React, { Component } from 'react';
import styled from 'styled-components';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import Button from '../../../../components/Button';
import ListHeader from '../../../../components/List/Header';
import ListRow from '../../../../components/List/Row';
import Icon from '../../../../components/Icon';
import CountryLabel from '../../../../components/CountryLabel';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

const TasterSubscriptionsContainer = styled.div`
  a {
    text-decoration: none;
    color: #e44b27;
  }

  .tasterListContainer {
    margin-top: -5px;
    margin-bottom: 50px;
  }

  .tasterInnerListContainer {
    max-height: 461px;
    overflow-y: auto;
  }

  .zoneItemContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    margin-left: 18px;
    width: calc(33% + 18px);
  }

  .zoneItemIcon {
    margin-left: 18px;
    margin-right: 31px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .zoneItemIconDisabled {
    margin-left: 18px;
    margin-right: 26px;
    color: #868e96;
    width: 17px;
    height: 17px;
  }

  .tasterItemContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 60px;
    height: 100%;
    margin-left: 10px;
    width: 67%;
    opacity: 1;
  }

  .tasterItemName {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    color: #233545;
  }

  .tasterItemNameDisabled {
    opacity: 0.5;
  }

  .tasterItemSubscribed {
    margin-left: auto;
    font-size: 12px;
    margin-right: 30px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: ${(props) => props.theme.colors['dark']};
  }

  .tasterItemNotSubscribed {
    font-family: ${(props) => props.theme.fonts.sfcompact_italic};
    color: #e44b27;
    text-decoration: underline;
  }

  .tasterItemNotSubscribed:hover {
    cursor: pointer;
  }
`;

class TasterSubscriptions extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], sortAscending: [] };
  }

  sortColumn(key) {
    let { data, sortAscending } = this.state;
    data.sort(function (a, b) {
      return String(a[key]).localeCompare(String(b[key]));
    });
    if (sortAscending) {
      this.setState({ data, sortAscending: !sortAscending });
    } else {
      this.setState({
        data: data.reverse(),
        sortAscending: !sortAscending
      });
    }
  }

  componentDidMount() {
    this.setState({
      data: this.props.data
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        data: this.props.data
      });
    }
  }

  formatCountry(item) {
    return (item.countryCode = item.country_origin.code);
  }

  render() {
    const { admin } = this.props;
    const { data } = this.state;
    return (
      <TasterSubscriptionsContainer>
        <Card>
          <CardHeader
            title={I18n.t('admin.subscriptions.title')}
            icon="espace"
            iconContainer
            iconPosition="left"
            textTransform="normal"
            rightComponents={
              admin && (
                <Link to="/user-space/subscriptions">
                  <Button
                    label={I18n.t('admin.subscriptions.button')}
                    width="200px"
                    height="32px"
                    widthText="130px"
                    borderRadius="24px"
                    textTransform="normal"
                    fontFamily="SFCompactText"
                    icon="lock"
                    iconLeft
                  />
                </Link>
              )
            }
          />
          <div className="tasterListContainer">
            <ListHeader
              columns={[
                {
                  name: I18n.t('admin.subscriptions.origin'),
                  length: '34%',
                  padding: '65px',
                  sort: true,
                  onSort: () => this.sortColumn('countryCode')
                },
                {
                  name: I18n.t('admin.subscriptions.journalist'),
                  length: '66%',
                  sort: true,
                  onSort: () => this.sortColumn('name')
                }
              ]}
            />
            <div className="tasterInnerListContainer">
              {data.map((item, index) => (
                <ListRow
                  dark={index % 2 === 0}
                  disabled={!item.data}
                  key={`tasterRow-${index}`}
                >
                  <div className="zoneItemContainer">
                    <div
                      className={
                        !item.data ? 'zoneItemIconDisabled' : 'zoneItemIcon'
                      }
                    >
                      <Icon icon={!item.data ? 'close' : 'check'} />
                    </div>
                    {item.country_origin ? (
                      <CountryLabel
                        className="zoneItemLabel"
                        name={this.formatCountry(item)}
                      />
                    ) : (
                      <p> - </p>
                    )}
                  </div>
                  <div className="tasterItemContainer">
                    <p
                      className={
                        !item.data
                          ? 'tasterItemNameDisabled tasterItemName'
                          : 'tasterItemName'
                      }
                    >
                      {item.name}
                    </p>
                    <p
                      className={
                        !item.data
                          ? 'tasterItemNameDisabled tasterItemSubscribed'
                          : 'tasterItemSubscribed'
                      }
                    >
                      {item.data
                        ? I18n.t('admin.subscriptions.subscribed')
                        : I18n.t('admin.subscriptions.notSubscribed')}
                    </p>
                  </div>
                </ListRow>
              ))}
            </div>
          </div>
        </Card>
      </TasterSubscriptionsContainer>
    );
  }
}

export default TasterSubscriptions;
